<style lang="scss">
.user-div {
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(107, 70, 193, 0.05);
  transition: all 0.3s ease;
  padding: 2.5rem;
  margin: 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(to bottom, #6B46C1, #805AD5);
    border-radius: 2px;
  }

  &:hover {
    box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(107, 70, 193, 0.1);
    transform: translateY(-2px);
  }

  .m-3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 2rem;
    display: block;
    padding-left: 1rem;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -0.5rem;
      left: 1rem;
      width: 2rem;
      height: 2px;
      background: linear-gradient(to right, #6B46C1, #805AD5);
      border-radius: 1px;
    }
  }
}

.user-info-from {
  margin-left: 2rem;
  margin-top: 2rem;
  padding: 0 1rem;
}

.empower-list-div {
  background: #ffffff;
  margin: 2.5rem 2rem 5rem 2rem !important;
  padding: 2.5rem !important;
  width: 90%;
  border-radius: 16px;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(107, 70, 193, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(to bottom, #6B46C1, #805AD5);
    border-radius: 2px;
  }

  &:hover {
    box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(107, 70, 193, 0.1);
  }
}

.console-content-div {
  margin-top: 1rem;
}

.el-table__cell {
  text-align: center !important;
}

.mymoney-div,
.mygrade-div {
  background: #ffffff;
  height: 7rem;
  width: 20rem !important;
  padding: 0 !important;
  border-radius: 16px;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(107, 70, 193, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(107, 70, 193, 0.1);
    transform: translateY(-2px);
  }
}

.mymoney-title,
.mygrade-title {}

.mymoney-header,
.mygrade-header {
  width: 20rem !important;
  padding: 1rem 1.25rem;
  font-size: 0.95rem;
  border-bottom: 1px solid rgba(107, 70, 193, 0.1);
  background: #ffffff;
  font-weight: 500;
  color: #1a1a1a;
}

.mymoney-num {
  font-size: 2rem;
  font-weight: 700;
  width: fit-content;
  margin: 0 auto;
  background: linear-gradient(135deg, #6B46C1 0%, #805AD5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.02em;
}

.grade_name {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  width: fit-content;
  margin: 0.75rem auto;
  letter-spacing: -0.02em;
}

.grade_content {
  font-size: 0.95rem;
  color: #64748b;
  width: fit-content;
  margin: 0.5rem auto;
  letter-spacing: 0.01em;
}

.mygrade-content {
  width: fit-content;
  margin: 0 auto;
  padding: 0.75rem 0;
}

.mymoney-puy,
.mygrade-up {
  color: white;
  width: fit-content;
  float: right;
  background: linear-gradient(135deg, #7940ff 0%, #01e0ff 100%);
  padding: 0.35rem 1rem;
  text-decoration: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
  letter-spacing: 0.01em;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(107, 70, 193, 0.25);
    color: white;
    cursor: pointer;
  }
}

.mymoney-puy,
.mygrade-up:hover {
  cursor: pointer;
}

.avatar-uploader {
  width: 8rem;
  height: 8rem;
  margin-left: 5px;
  border: 2px dashed rgba(107, 70, 193, 0.2);
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  cursor: pointer;

  &:hover {
    border-color: rgba(107, 70, 193, 0.4);
    background: #ffffff;
  }

  .el-icon {
    font-size: 2rem;
    color: #6B46C1;
  }
}

.avatar-upload-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.liu-el-image {
  width: 8rem;
  height: 8rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.liu-text-info {
  color: #6B46C1;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #805AD5;
    text-decoration: underline;
  }
}

.pagination {
  margin: 1.5rem auto 0;
  width: fit-content;
}

.money_total_num {
  font-size: 2rem;
  color: red;
  margin-right: 0.5rem;
}

.user-empower-header {
  margin-bottom: 2rem;

  .el-button {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(107, 70, 193, 0.25);
    }
  }
}

.empower_data {
  width: 80vw;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  .liu-text-warning {
    color: #f59e0b;
    font-weight: 500;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1.25rem;

    &::before {
      content: '\26A0';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .liu-text-danger {
    color: #ef4444;
    font-weight: 500;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1.25rem;

    &::before {
      content: '\274C';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.skm-div {
  width: fit-content;
  padding: 2.5rem !important;
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(107, 70, 193, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(to bottom, #6B46C1, #805AD5);
    border-radius: 2px;
  }

  &:hover {
    box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(107, 70, 193, 0.1);
    transform: translateY(-2px);
  }

  .m-3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 2rem;
    display: block;
    padding-left: 1rem;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -0.5rem;
      left: 1rem;
      width: 2rem;
      height: 2px;
      background: linear-gradient(to right, #6B46C1, #805AD5);
      border-radius: 1px;
    }
  }
}

.danger-row {
  background-color: #f56c6c;
}

//移动端
@media screen and (max-width: 768px) {

  .mymoney-div,
  .mygrade-div {
    margin: 2rem;
    height: 6rem;
  }

  .empower-list-div {
    width: 95%;
    margin: 1.5rem auto !important;
    padding: 1.5rem !important;
  }

  .user-div {
    width: 95vw !important;
    margin: 1.5rem;
    padding: 2rem;
  }

  .empower_data {
    margin-bottom: 3rem;
    width: 80rem;
  }

  .console-content-div {
    width: fit-content;
    background-color: rgb(242 242 242) !important;
    height: fit-content;
  }

  .skm-div {
    margin-left: 1rem;
    width: 100vw !important;
    padding: 3rem !important;
    background-color: white;
    margin-top: 1rem !important;
  }

  .avatar-uploader {
    width: 6rem;
    height: 6rem;
  }

  .liu-el-image {
    width: 6rem;
    height: 6rem;
  }

  .user-div {
    margin-left: 1rem;
  }

  :deep(.el-form-item__label) {
    font-size: 0.95rem;
  }
}

// pc端
@media screen and (min-width: 768px) {

  .mymoney-div,
  .mygrade-div {
    margin: 2rem;
  }

  .user-div {
    margin: 2rem;
  }

  .skm-div {
    margin-left: 2rem;
    margin-top: 2rem !important;
  }
}

:deep(.el-form-item__label) {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 1rem;
  margin-bottom: 0.75rem;
  letter-spacing: 0.01em;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
}

:deep(.el-input__wrapper) {
  background: #ffffff;
  box-shadow: 0 0 0 1px rgba(107, 70, 193, 0.15);
  transition: all 0.2s ease;
  border-radius: 10px;
  padding: 0 1.25rem;
  height: 2.75rem;

  &:hover {
    box-shadow: 0 0 0 1px rgba(107, 70, 193, 0.3);
  }

  &:focus-within {
    box-shadow: 0 0 0 2px rgba(107, 70, 193, 0.2);
  }
}

:deep(.el-input__inner) {
  font-size: 1rem;
  color: #1a1a1a;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.1);

  &::placeholder {
    color: #94a3b8;
    font-weight: 400;
    opacity: 0.8;
  }
}

:deep(.el-button) {
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.2s ease;
  height: 2.75rem;
  padding: 0 1.75rem;
  letter-spacing: 0.01em;
}

:deep(.el-button--primary) {
  background: linear-gradient(135deg, #6B46C1 0%, #805AD5 100%);
  border: none;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(107, 70, 193, 0.25);
  }
}

:deep(.el-table) {
  --el-table-border-color: rgba(107, 70, 193, 0.1);
  --el-table-header-bg-color: #f8fafc;

  th {
    background: #f8fafc;
    font-weight: 600;
    color: #1a1a1a;
    font-size: 0.95rem;
    letter-spacing: 0.01em;
    padding: 1.25rem 1rem;
    border-bottom: 1px solid rgba(107, 70, 193, 0.1);
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 1rem;
      width: calc(100% - 2rem);
      height: 1px;
      background: linear-gradient(to right, rgba(107, 70, 193, 0.1), rgba(107, 70, 193, 0.2), rgba(107, 70, 193, 0.1));
    }
  }

  td {
    color: #1a1a1a;
    font-size: 0.95rem;
    padding: 1.25rem 1rem;
    font-weight: 500;
    transition: all 0.2s ease;
    border-bottom: 1px solid rgba(107, 70, 193, 0.05);

    &:hover {
      background: rgba(107, 70, 193, 0.02);
    }
  }

  tr {
    transition: all 0.2s ease;

    &:hover {
      td {
        background: rgba(107, 70, 193, 0.02);
      }
    }
  }

  .el-input {
    .el-input__wrapper {
      box-shadow: 0 0 0 1px rgba(107, 70, 193, 0.15);
      transition: all 0.2s ease;
      padding: 0 1rem;
      height: 2.5rem;

      &:hover {
        box-shadow: 0 0 0 1px rgba(107, 70, 193, 0.3);
      }

      &.is-focus {
        box-shadow: 0 0 0 2px rgba(107, 70, 193, 0.2);
      }
    }

    .el-input__inner {
      font-size: 0.95rem;
      color: #1a1a1a;
      font-weight: 500;

      &::placeholder {
        color: #94a3b8;
        font-weight: 400;
      }
    }
  }

  .el-button {
    padding: 0.5rem 1.25rem;
    font-size: 0.9rem;
    font-weight: 500;
    border-radius: 8px;
    transition: all 0.2s ease;
    letter-spacing: 0.01em;

    &--danger {
      background: #ef4444;
      border: none;
      color: white;

      &:hover {
        background: #dc2626;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
      }
    }

    &--success {
      background: #10b981;
      border: none;
      color: white;

      &:hover {
        background: #059669;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
      }
    }
  }
}

.liu-text-info {
  color: #1a1a1a;
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: 0.01em;
}



:deep(.el-pagination) {
  margin-top: 2.5rem;
  justify-content: center;

  .el-pagination__total,
  .el-pagination__sizes {
    margin-right: 1.25rem;
    font-size: 0.95rem;
  }

  .btn-prev,
  .btn-next {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>

<template>
  <div class="common-layout" style="padding-right: 0;">
    <el-container style="height: 100vh;width: 100vw;">
      <el-aside style="width: fit-content;">
        <UserHead />
      </el-aside>
      <el-container>
        <el-header style="padding: 0;">
          <HeadTop />
        </el-header>
        <el-main style="padding: 0;overflow: auto;   background-color: rgb(242 242 242) !important;">
          <div class="console-content-div">
            <div class="row">
              <div class="mymoney-div rounded shadow">
                <div class="mymoney-header">
                  <span class="mymoney-title">我的余额</span>
                  <a @click.prevent="puy_money()" class="mymoney-puy">在线充值</a>
                  <a @click.prevent="withdrawalView()" class="mymoney-puy mr-3">提现</a>
                </div>
                <div class="mymoney-num">
                  {{ user_conf.money }}元</div>
              </div>
            </div>

            <div class="row" style="margin: 0;">
              <!-- 用户信息管理 -->
              <div class="col-md-6 user-div pt-3 pb-5 user-info-div rounded shadow">
                <span class="m-3">用户信息管理</span>
                <div class="user-info-from">
                  <el-form :label-position="labelPosition" label-width="auto" :rules="rules" ref="userInfo_form"
                    :model="user_conf" style="max-width: 90%">
                    <el-form-item label="头像">
                      <div class="avatar-upload-wrapper">
                        <el-avatar v-if="user_conf.avatar" :size="60" :src="user_conf.avatar" />
                        <el-avatar v-else :size="60" style="background: #409EFF;">
                          <el-icon :size="30">
                            <User />
                          </el-icon>
                        </el-avatar>
                        <el-upload :show-file-list="false" class="avatar-uploader-btn" :action="upload.url"
                          :headers="upload.header" :data="upload.avatar_data" accept="image/*"
                          :on-success="handleSuccess" :before-upload="beforeAvatarUpload">
                          <el-button size="small" type="primary" class="ml-3">上传头像</el-button>
                        </el-upload>
                      </div>
                    </el-form-item>
                    <el-form-item label="用户编号">
                      <el-input disabled v-model="user_conf.uid" />
                    </el-form-item>
                    <el-form-item label="用户名" prop="username">
                      <el-input v-model="user_conf.username" />
                    </el-form-item>
                    <el-form-item label="联系方式">
                      <el-input v-model="user_conf.contact" placeholder="比如：微信号yishousup" />
                    </el-form-item>
                    <el-form-item label="我的上级" prop="higher_uid">
                      <el-input disabled v-model="user_conf.higher_uid" />
                    </el-form-item>
                    <el-form-item label="绑定邮箱">
                      <el-input disabled v-model="user_conf.user_email" />
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                      <el-input placeholder="***********" v-model="user_conf.password" />
                    </el-form-item>
                    <el-form-item class="form-el-btn">
                      <el-button type="primary" @click="openDialog('消息', '您确认要修改用户信息吗', true, 'setUserInfo')">
                        保存
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <div class="col-md-4 skm-div pt-3 pb-5  rounded shadow">
                <span class="m-3">收款信息管理</span>
                <div class="user-info-from">
                  <el-form label-position="left" label-width="auto">
                    <el-form-item label="微信">
                      <el-image :preview-src-list="[user_conf.wxQR_code]" v-if="!isNull(user_conf.wxQR_code)"
                        :src="user_conf.wxQR_code" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :initial-index="4"
                        fit="cover" class="liu-el-image" />
                      <el-upload :show-file-list="false" class="avatar-uploader" :action="upload.url"
                        :headers="upload.header" :drag="isNull(user_conf.wxQR_code)" :data="upload.wx_data"
                        multiple="false" accept="image/*" :limit="1" :on-exceed="handleExceed"
                        :on-success="handleSuccess" :before-upload="beforeAvatarUpload">
                        <el-icon v-if="isNull(user_conf.wxQR_code)">
                          <Plus />
                        </el-icon>
                        <span class="liu-text-info" style="line-height: 6rem;" v-else>点击更改</span>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="支付宝">
                      <el-image :preview-src-list="[user_conf.zfbQR_code]" v-if="!isNull(user_conf.zfbQR_code)"
                        :src="user_conf.zfbQR_code" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :initial-index="4"
                        fit="cover" class="liu-el-image" />
                      <el-upload :show-file-list="false" v-model="upload.zfb_code" class="avatar-uploader"
                        :action="upload.url" :headers="upload.header" :drag="isNull(user_conf.zfbQR_code)"
                        :data="upload.zfb_data" multiple="false" accept="image/*" :limit="1" :on-exceed="handleExceed"
                        :on-success="handleSuccess" :before-upload="beforeAvatarUpload">
                        <el-icon v-if="isNull(user_conf.zfbQR_code)">
                          <Plus />
                        </el-icon>
                        <span class="liu-text-info ml-3" style="line-height: 6rem;" v-else>点击更改</span>
                      </el-upload>
                    </el-form-item>

                  </el-form>
                </div>
              </div>
            </div>
            <!-- 授权列表 -->
            <div class="empower-list-div rounded shadow">
              <div class="user-empower-header">
                <el-button type="primary" class="ml-5 mt-1 mb-3" @click="addEmpowerFun('dialog')">添加授权</el-button>
              </div>
              <el-table :data="empower_data" class="empower_data">
                <el-table-column prop="includes_name" label="插件名" />
                <el-table-column prop="version_name" label="插件版本" />
                <el-table-column prop="includes_id" label="插件id" width="100" />
                <el-table-column prop="add_date" label="添加时间" />
                <el-table-column label="授权字段" width="180">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.empower_host"
                      @change="updateHostClick(scope.row.empower_id, scope.row.empower_host)"
                      placeholder="请输入内容"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="修改记录" width="200">
                  <template v-slot="scope">
                    <div style="display: flex; align-items: center; gap: 0.4rem;">
                      <el-tag size="small" :type="scope.row.modify_count >= 10 ? 'danger' : 'info'">
                        {{ scope.row.modify_count || 0 }}/10
                      </el-tag>
                      <el-tooltip placement="left" width="400" v-if="scope.row.modify_history">
                        <template #content>
                          <div style="max-width: 350px;">
                            <div style="margin-bottom: 4px; font-weight: 600; color: #fbbf24;">修改规则</div>
                            <div style="margin-bottom: 8px; font-size: 12px; line-height: 1.6;">
                              1. 每月可免费修改授权的次数有限，超出后需要付费修改<br>
                              2. 每个授权总共可免费修改的次数有限，超出后需要付费修改
                            </div>
                            <div style="border-top: 1px solid #555; padding-top: 8px;">
                              <div v-for="(item, idx) in parseModifyHistory(scope.row.modify_history)" :key="idx"
                                style="font-size: 12px; line-height: 1.8; color: #d1d5db;">
                                <span style="display: flex; align-items: center; gap: 4px;">
                                  <span>{{ item.time }}</span>
                                  <el-tag size="small" :type="item.is_paid == 1 ? 'success' : 'info'"
                                    style="height: 18px; line-height: 18px; font-size: 11px; padding: 0 4px;">
                                    {{ item.is_paid == 1 ? '付费' : '免费' }}
                                  </el-tag>
                                </span>
                                <span style="color: #9ca3af;">{{ item.old_host }}</span>
                                <span style="color: #6b7280; margin: 0 4px;">→</span>
                                <span style="color: #93c5fd;">{{ item.new_host }}</span>
                              </div>
                            </div>
                          </div>
                        </template>
                        <el-button size="small" text type="primary" style="padding: 0;">
                          查看记录
                        </el-button>
                      </el-tooltip>
                      <span v-else style="font-size: 0.75rem; color: #c0c4cc;">暂无记录</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" width="180">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.remark"
                      @change="updateRemarkClick(scope.row.empower_id, scope.row.remark)"
                      placeholder="请输入内容"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="add_uid" label="授权者id" width="150" />
                <el-table-column prop="end_date" label="到期时间">
                  <template v-slot="scope">
                    <div class="liu-text-info" v-if="getEndDateColor(scope.row.end_date) == 1">{{ scope.row.end_date }}
                    </div>
                    <div class="liu-text-warning" v-else-if="getEndDateColor(scope.row.end_date) == 2">{{
                      scope.row.end_date
                    }}(即将到期)</div>
                    <div class="liu-text-danger" v-else>{{ scope.row.end_date }}(已到期)</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <el-button @click="deleteAuthDialog(scope.row.empower_id)" type="danger"
                      v-if="getEndDateColor(scope.row.end_date) === 3 || scope.row.is_free == 1">删除</el-button>
                    <el-button @click="renewAuthDialog(scope.row.empower_id, scope.row.includes_id, scope.row.version)"
                      type="success">续费</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination class="pagination" v-model:current-page="empower_Conf.currentPage"
                v-model:page-size="empower_Conf.pageSize" :page-sizes="[10, 25, 50]" :disabled="empower_Conf.disabled"
                layout="total, sizes, prev, pager, next, jumper" :total="empower_Conf.total" @size-change="sizeChange"
                @current-change="currentChange" />
            </div>
            <el-dialog :close-on-click-modal="false" v-model="centerDialog.isShow" :title="centerDialog.title"
              width="500" align-center>
              <span>{{ centerDialog.content }}</span>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="centerDialog.isShow = false">关闭</el-button>
                  <el-button type="primary" @click="centerDialogClick(centerDialog.clickBind)">
                    确认
                  </el-button>
                </div>
              </template>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" v-model="trendsDialog.dialogVisible" title="选择等级"
              style="width: fit-content;" align-center>
              <el-form label-position="top" style="width: 40rem;" label-width="auto">
                <el-form-item label="升级等级">
                  <el-select v-model="select_option" placeholder="请选择需要升级的等级">
                    <el-option v-for="(item) in grade_Option" :key="item.grade_id"
                      :label="item.name + '---' + item.price_diff + '元'" :value="item.grade_id" />
                    <el-option v-if="grade_Option.length == 0" label="您已经是最高等级了" />
                  </el-select>
                </el-form-item>
              </el-form>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="trendsDialog.dialogVisible = false">关闭</el-button>
                  <el-button type="primary" @click="centerDialogClick('gradeUp')">
                    确认升级
                  </el-button>
                </div>
              </template>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" v-model="addEmpower_dialog.dialogVisible" title="添加授权"
              align-center>
              <el-form label-position="top" style="width:30rem;margin: 2rem auto;" label-width="auto">
                <el-form-item label="授权插件" v-show="!appConf.isRenew">
                  <el-select v-model="includes_data.select_option" @change="getPluginVersions" placeholder="请选择插件">
                    <el-option v-for="(item) in includes_data.includes_list" :key="item.id"
                      :label="item.id + '---' + item.platform + '---' + item.name" :value="item.id" />
                    <el-option v-if="includes_data.includes_list.length == 0" disabled>--暂无插件/您不是任何插件的代理--</el-option>
                  </el-select>
                </el-form-item>

                <!-- Add version selection dropdown -->
                <el-form-item label="功能版本" v-show="!appConf.isRenew">
                  <el-select v-model="version_data.select_option" @change="onVersionChange" placeholder="请选择功能版本"
                    :disabled="version_data.version_list.length === 0">
                    <el-option v-for="(item) in version_data.version_list" :key="item.version"
                      :label="item.version + '--' + item.versionName" :value="item.version" />
                    <el-option v-if="version_data.version_list.length === 0 && includes_data.select_option"
                      disabled>--该插件无版本信息--</el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="授权时长单位">
                  <el-select v-model="time_meal_data.select_option" @change="setTimeMeal(time_meal_data.select_option)"
                    placeholder="请选择时长单位" :disabled="time_meal_data.time_meal_list.length === 0">
                    <el-option v-for="(item) in time_meal_data.time_meal_list" :key="item.meal_id"
                      :label="item.time_unit + '---每' + item.time_unit + ' ' + item.price + '元'"
                      :value="item.meal_id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="授权时长">
                  <el-input-number v-model="time_meal_data.num" :min="time_meal_data.min" :max="time_meal_data.max" />
                  <div v-if="time_meal_data.unit != ''" class="d-flex align-items-center">
                    <el-icon>
                      <CloseBold />
                    </el-icon><span>{{ time_meal_data.unit }}</span>
                  </div>
                </el-form-item>
                <el-form-item label="绑定邮箱" v-show="!appConf.isRenew">
                  <el-input v-model="addEmpower_dialog.user_email" placeholder="若是普通用户则填写当前绑定邮箱"
                    title="若是普通用户则只能为自己授权" />
                </el-form-item>
                <el-form-item label="授权字段(域名/ip等)" v-show="!appConf.isRenew">
                  <el-input v-model="addEmpower_dialog.host" />
                </el-form-item>
                <el-form-item></el-form-item>
                <el-form-item label="总计:" v-if="time_meal_data.unit != ''">
                  <div class="d-flex align-items-center">
                    <span class="money_total_num">{{ getTimePrice }}</span>元
                  </div>
                </el-form-item>
              </el-form>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="addEmpower_dialog.dialogVisible = false">关闭</el-button>
                  <el-button type="primary" v-show="!appConf.isRenew"
                    @click="openDialog('消息', '您确定要添加此授权吗？您需要支付' + getTimePrice + '元', true, 'addEmpower')">
                    添加授权
                  </el-button>
                  <el-button type="primary" v-show="appConf.isRenew"
                    @click="openDialog('消息', '您确定要续费此授权吗？您需要支付' + getTimePrice + '元', true, 'renewEmpower')">
                    添加授权
                  </el-button>
                </div>
              </template>
            </el-dialog>
            <!-- 余额充值 -->
            <el-dialog v-model="balanceRechargeDialog.isShow" title="充值" width="500" align-center>
              <div class="ml-4">
                <div class="mt-3">
                  <span>充值金额</span>
                  <el-input :min="balanceRechargeDialog.checkType.min" :max="balanceRechargeDialog.checkType.max"
                    v-model="balanceRechargeDialog.money" style="width: 80%" class="ml-3" size="large"
                    :placeholder="'单笔充值范围:' + balanceRechargeDialog.checkType.min + '--' + balanceRechargeDialog.checkType.max"
                    type="number" />
                </div>
                <div class="mt-3">
                  <span>支付方式</span>
                  <el-select v-model="balanceRechargeDialog.type" placeholder="支付方式" size="large" style="width: 80%"
                    class="ml-3" @change="payTypeChange">
                    <el-option v-for="item in balanceRechargeDialog.types" :key="item.type"
                      :label="item.name + '(手续费' + item.fee + ')'" :value="item.type" />
                  </el-select>
                </div>
              </div>
              <template #footer>
                <div class="dialog-footer">
                  <el-button @click="balanceRechargeDialog.isShow = false">取消</el-button>
                  <el-button type="primary" @click="toRecharge()">
                    确定
                  </el-button>
                </div>
              </template>
            </el-dialog>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
  <!-- <div class="d-flex flex-row">
    <UserHead />
    
  </div> -->
</template>

<script lang="ts" setup>
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import { isNull, getEmpower, EmpowerResponse } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage, } from 'element-plus'
import type { UploadProps } from 'element-plus'
import { Grade } from '@/types/gradeInterface'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { Platform } from '@element-plus/icons-vue/dist/types';
const baseURL = process.env.VUE_APP_API_BASE_URL;

var labelPosition = 'right'
var user_conf = ref({
  uid: '',
  username: '',
  user_email: '',
  higher_uid: "",
  password: "",
  money: "",
  contact: "",
  avatar: "",
  higher_email: "",
  grade_id: -1,
  grade_name: "",
  grade_content: "",
  sell_price: 0,
  wxQR_code: '',
  zfbQR_code: ''
})
var appConf = ref({
  isRenew: false,
  empower_id: -1,
})
var balanceRechargeDialog = ref({
  isShow: false,
  money: "",
  types: [],
  type: "",
  checkType: { min: 0, max: 0 }
})
var deleteAuth_id = -1;
const getTimePrice = computed(() => {
  const product = time_meal_data.value.price * time_meal_data.value.num;
  return product.toFixed(2);
})

var grade_data = reactive<Grade[]>([]);

const select_option = ref()
var empower_data = ref([
  {
    includes_name: '',
    id: "",
    includes_id: "",
    add_date: '',
    empower_host: '',
    higher_uid: "",
    end_date: ""
  },
])
var updateHost_data = ref({
  empower_id: -1,
  update_host: "",
  paid: 0
})
var updateRemark_data = ref({
  empower_id: -1,
  remark: ""
})
var centerDialog = ref({
  isShow: false,
  title: "info",
  content: "content",
  clickBind: ""
})
var trendsDialog = ref({
  dialogTitle: "",
  dialogVisible: false
})
var addEmpower_dialog = ref({
  dialogTitle: "",
  dialogVisible: false,
  select_option: "",
  time_Option: [],
  user_email: "",
  host: ""
})
var includes_data = ref({
  select_option: "",
  includes_list: [{
    id: "",
    grade_name: "",
    name: "",
    platform: ""
  }
  ]
})
interface grade_dataIn {
  grade_id: number,
  name: string,
  content: string,
  sell_price: number,
  higher_reward: number,
  isPoss: boolean,
  price_diff: number,
}
var grade_Option = ref<grade_dataIn[]>([]);
const validateUsername = (rule: any, value: any, callback: any) => {
  const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (regExp.test(value)) {
    callback(new Error('不能有特殊字符'));
  } else {
    callback();
  }
}
const rules = {
  password: [
    { min: 6, max: 20, message: '长度在6-20位', trigger: ['change', 'blur'] },
  ],
  username: [
    { min: 1, max: 10, message: '长度在1-10位', trigger: ['change', 'blur'] },
    { validator: validateUsername, trigger: ['blur', 'change'] },
  ]
}
const userInfo_form = ref(null)
const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
  if (isShow == false) {
    centerDialog.value.isShow = false
  }
  else {
    centerDialog.value.title = title
    centerDialog.value.content = content
    centerDialog.value.isShow = true
    centerDialog.value.clickBind = clickBind
  }
}
const centerDialogClick = (act: string) => {
  switch (act) {
    case "setUserInfo":
      submitForm('setUserInfo');
      break;
    case 'updateHost':
      submitForm('updateHost');
      break;
    case 'gradeUp':
      submitForm('gradeUp');
      break;
    case 'addEmpower':
      addEmpowerFun('post');
      break;
    case 'renewEmpower':
      renewEmpowerFun();
      break;
    case 'deleteAuth':
      deleteAuth(deleteAuth_id)
      break;
    default:
      break;
  }
}
const updateHostClick = (empower_id: number, update_host: string) => {
  updateHost_data.value.empower_id = empower_id
  updateHost_data.value.update_host = update_host
  updateHost_data.value.paid = 0
  openDialog('消息', '您确认要修改此授权吗', true, 'updateHost')
}

// 解析修改历史JSON字符串
const parseModifyHistory = (history: string) => {
  if (!history) return []
  try {
    return JSON.parse(history)
  } catch {
    return []
  }
}
const updateRemarkClick = (empower_id: number, remark: string) => {
  updateRemark_data.value.empower_id = empower_id
  updateRemark_data.value.remark = remark
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.post(baseURL + "/userApi/setRemark", updateRemark_data.value, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        ElMessage.success(res.data.msg)
        setTimeout(() => {
          location.reload()
        }, 1000);
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}

const renewAuthDialog = (empower_id: number, includes_id: string, version: number) => {
  appConf.value.isRenew = true;
  addEmpower_dialog.value.dialogVisible = true
  includes_data.value.select_option = includes_id;
  appConf.value.empower_id = empower_id;
  getTimeMeal(includes_id, version + "");

}
const renewEmpowerFun = () => {
  openLoading();
  centerDialog.value.isShow = false
  const headers = {
    'token': localStorage.getItem("token")
  }
  // const data = new FormData()
  const data = {
    empower_id: appConf.value.empower_id
    , time_act: time_meal_data.value.meal_id
    , time_num: time_meal_data.value.num
  }
  // data.append("empower_id", appConf.value.empower_id+"")
  // data.append("time_act", time_meal_data.value.meal_id + "")
  // data.append("time_num", time_meal_data.value.num + "")
  axios.post(baseURL + "/userApi/renewSelfEmpower", data, { timeout: 10000, headers: headers })
    .then(async (res) => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        addEmpower_dialog.value.dialogVisible = false
        ElMessage.success(res.data.msg)
        await getUserInfo();
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('续费失败：' + err.message)
    })
}
const getUserInfo = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/userApi/getUserInfo", { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        user_conf.value = res.data.data
        user_conf.value.higher_email = res.data.data.higher_email
        localStorage.setItem("user_conf", JSON.stringify(user_conf.value))
        empower_data.value = res.data.empower_data;
        empower_Conf.value.total = res.data.total_empower
        if (res.data.total_empower < empower_Conf.value.pageSize) {
          empower_Conf.value.disabled = true
        }
      }
      else {
        ElMessage.error(res.data.msg)
        if (res.data.code == 401) {
          ElMessage.error(res.data.msg)
          setTimeout(() => {
            location.href = "/Login"
          }, 500);
        }
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('获取用户信息失败：' + err.message)
    })
}
const submitForm = (act: string) => {
  openLoading()
  centerDialog.value.isShow = false
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  switch (act) {
    case "setUserInfo":
      (userInfo_form as any).value.validate((valid: any) => {
        if (!valid) {
          ElMessage.error('数据格式不符合要求')
        }
        else {
          data.append("act", "setUserInfo");
          if (user_conf.value.password) {
            data.append("password", user_conf.value.password);
          }
          if (user_conf.value.username) {
            data.append("username", user_conf.value.username);
          }
          if (user_conf.value.user_email) {
            data.append("user_email", user_conf.value.user_email);
          }
          if (user_conf.value.contact) {
            data.append("contact", user_conf.value.contact);
          }
          if (user_conf.value.avatar) {
            data.append("avatar", user_conf.value.avatar);
          }
          axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
            .then(res => {
              fullscreenLoading.close()
              if (res.data.code == 401) {
                ElMessage.error('您没有登录')
                setTimeout(() => {
                  location.href = "/Login"
                }, 1000);
              }
              else if (res.data.code == 200) {
                ElMessage.success(res.data.msg)
                setTimeout(() => {
                  location.reload()
                }, 1000);
              }
              else {
                ElMessage.error(res.data.msg)
              }
            })
            .catch(err => {
              fullscreenLoading.close()
              console.log(err)
              ElMessage.error('请求失败：' + err.message)
            })
        }
      })
      break;
    case "updateHost":
      data.append("act", "updateHost");
      if (updateHost_data.value.empower_id && updateHost_data.value.empower_id != -1) {
        data.append("empower_id", String(updateHost_data.value.empower_id));
      }
      if (updateHost_data.value.update_host && updateHost_data.value.update_host != "") {
        data.append("update_host", updateHost_data.value.update_host);
      }
      if (updateHost_data.value.paid == 1) {
        data.append("paid", "1");
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else if (res.data.code == 4031) {
            // 免费修改次数已用完，弹出确认框展示付费金额
            updateHost_data.value.paid = 1
            const price = (res.data.data && res.data.data.paid_price) ? res.data.data.paid_price : ''
            openDialog('付费修改确认', '免费修改次数已用完，付费修改将扣除 ' + price + ' 元，是否继续？', true, 'updateHost')
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;
    case 'gradeUp':
      data.append("act", "gradeUp")
      data.append("grade_id", select_option.value)
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;

    default:
      break;
  }
}
const puy_money = () => {
  balanceRechargeDialog.value.isShow = true;
  axios.get(baseURL + "/pay/payType", { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      if (res.data.code == 200) {
        balanceRechargeDialog.value.types = res.data.data.list
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })

}

const payTypeChange = (value: any) => {
  for (let i = 0; i < balanceRechargeDialog.value.types.length; i++) {
    const item = balanceRechargeDialog.value.types[i];
    if (item.type == value) {
      value = item
      break;
    }
  }
  balanceRechargeDialog.value.checkType = value;
}
const store = useStore();
const router = useRouter();
const toRecharge = () => {
  const money = parseInt(balanceRechargeDialog.value.money);
  const min = balanceRechargeDialog.value.checkType.min;
  const max = balanceRechargeDialog.value.checkType.max;
  if (money < min || money > max) {
    ElMessage.error('充值金额超出范围：[' + min + ',' + max + ']');
    return;
  }
  openLoading()
  axios.post(baseURL + "/pay/balanceRecharge", {
    name: "余额充值",
    money: balanceRechargeDialog.value.money,
    type: balanceRechargeDialog.value.type
  }, { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        balanceRechargeDialog.value.isShow = false;
        const data = res.data.data;
        const payType = data.pay_type;
        if (payType === 'alipay_dmf') {
          // 当面付：跳转二维码页面
          const outTradeNo = data.outTradeNo;
          sessionStorage.setItem("outTradeNo", outTradeNo);
          window.open("/alipayDMF", '_blank');
        } else if (payType === 'alipay_web' && data.url) {
          // 支付宝网站支付：返回的是HTML表单，需要写入新窗口自动提交
          const payWin = window.open('', '_blank');
          if (payWin) {
            payWin.document.write(data.url);
            payWin.document.close();
          } else {
            ElMessage.warning('请允许弹出窗口以完成支付');
          }
        } else if (data.url && data.url.startsWith('http')) {
          // 易支付：跳转支付链接
          window.open(data.url, '_blank');
        } else if (data.outTradeNo) {
          // 兼容旧逻辑：无url但有outTradeNo
          sessionStorage.setItem("outTradeNo", data.outTradeNo);
          window.open("/alipayDMF", '_blank');
        } else {
          ElMessage.warning('未获取到支付链接，请联系管理员');
        }
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const withdrawalView = () => {
  location.href = '/Withdrawal'
}
const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
  ElMessage.warning(
    `限制上传一个, 你选择了${files.length} 个文件,`
  )
}
const upload = ref({
  url: baseURL + "/xiaochuFile/uploadImg2",
  header: { 'token': localStorage.getItem('token') },
  wx_data: { 'act': 'uploadWxQR', 'token': localStorage.getItem('token') },
  zfb_data: { 'act': 'uploadZfbQR', 'token': localStorage.getItem('token') },
  avatar_data: { 'act': 'uploadAvatar', 'token': localStorage.getItem('token') },
  wx_code: "",
  zfb_code: '',
})
const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif' && rawFile.type !== 'image/jpg') {
    ElMessage.error('只能上传jpeg,png,gif,jp文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('文件大小不能超过 2MB!')
    return false
  }
  return true
}
const handleSuccess = (response: any) => {
  if (response.code == 200) {
    upload.value.wx_code = ""
    upload.value.zfb_code = ""
    ElMessage.success(response.msg)
    if (response.data.includes("avatar")) {
      user_conf.value.avatar = response.data + "?t=" + Date.now()
      ElMessage.success('头像上传并设置成功')
    } else if (response.data.includes("zfb_qr")) {
      user_conf.value.zfbQR_code = response.data + "?t=" + Date.now()
    } else {
      user_conf.value.wxQR_code = response.data + "?t=" + Date.now()
    }
  }
  else {
    ElMessage.error(response.msg)
  }
}
const empower_Conf = ref({
  total: 0,
  pageSize: 10,
  currentPage: 1,
  disabled: false,
})
const sizeChange = (val: number) => {
  empower_Conf.value.pageSize = val
  getEmpower1()
}
const currentChange = (val: number) => {
  empower_Conf.value.currentPage = val
  getEmpower1()
}
const getEmpower1 = async () => {
  const res: EmpowerResponse = await getEmpower(empower_Conf.value.currentPage, empower_Conf.value.pageSize);
  if (res.code == 200) {
    empower_Conf.value.total = res.total_empower
    if (res.data.total_empower < empower_Conf.value.pageSize) {
      empower_Conf.value.disabled = true
    }
    empower_data.value = res.data
  }
}
const addEmpowerFun = (act: string) => {
  if (act == 'dialog') {
    appConf.value.isRenew = false;
    addEmpower_dialog.value.dialogVisible = true;
    time_meal_data.value.time_meal_list = [];
    version_data.value.version_list = [];
    version_data.value.select_option = "";

    openLoading();
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    axios.get(baseURL + "/userApi/getIncludesAll", { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          includes_data.value.includes_list = res.data.data;
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('获取插件列表失败：' + err.message);
      });
  } else if (act == 'post') {
    openLoading();
    centerDialog.value.isShow = false;
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    const data = new FormData();
    data.append("includes_id", includes_data.value.select_option);
    data.append("host", addEmpower_dialog.value.host);
    data.append("email", addEmpower_dialog.value.user_email);
    data.append("time_act", time_meal_data.value.meal_id + "");
    data.append("time_num", time_meal_data.value.num + "");

    // Add version if selected
    if (version_data.value.select_option) {
      data.append("version", version_data.value.select_option);
    }

    axios.post(baseURL + "/userApi/addSelfEmpower", data, { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          addEmpower_dialog.value.dialogVisible = false;
          ElMessage.success(res.data.msg);
          getUserInfo(); // Refresh user info after successful authorization
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('添加授权失败：' + err.message);
      });
  }
}

var time_meal_data = ref({
  select_option: "",
  time_meal_list: [
    {
      meal_id: "",
      min: 1,
      max: 1,
      price: 0,
      time_unit: "",
    }
  ],
  num: 1,
  min: 1,
  max: 1,
  unit: "",
  price: 1,
  meal_id: ""
})
var version_data = ref({
  select_option: "",
  version_list: [] as { version: string; versionName: string }[]
})

// Add method to get plugin versions
const getPluginVersions = (soft_id: string) => {
  // Reset version selection and time meal data
  version_data.value.select_option = "";
  version_data.value.version_list = [];
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  // If no plugin selected, return
  if (!soft_id) return;

  openLoading();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  const data = {
    soft_id: soft_id
  };

  axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 200) {
        version_data.value.version_list = res.data.data.list || [];
        // If there's only one version, auto-select it
        if (res.data.data.list && res.data.data.list.length === 1) {
          version_data.value.select_option = res.data.data.list[0].version;
          onVersionChange(res.data.data.list[0].version);
        }
      } else {
        ElMessage.error(res.data.msg || '获取版本信息失败');
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('获取版本信息失败：' + err.message);
    });
}

// Add method to handle version change
const onVersionChange = (version: string) => {
  // Reset time meal selection
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  if (version && includes_data.value.select_option) {
    getTimeMeal(includes_data.value.select_option, version);
  }
}
const getTimeMeal = (includes_id: string, version?: string) => {
  openLoading();
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  data.append("includes_id", includes_id);
  data.append("act", "getTimeMeal");

  // Add version if provided
  if (version) {
    data.append("version", version);
  }

  axios.post(baseURL + "/userApi/getInfo", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 401) {
        ElMessage.error('您没有登录');
        setTimeout(() => {
          location.href = "/Login";
        }, 1000);
      } else if (res.data.code == 200) {
        time_meal_data.value.time_meal_list = res.data.data;
      } else {
        ElMessage.error(res.data.msg);
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('请求失败：' + err.message);
    });
}
const deleteAuthDialog = (empower_id: number) => {
  deleteAuth_id = empower_id
  openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
}
const deleteAuth = (empower_id: number) => {
  openLoading()
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  data.append("id", empower_id + "")
  axios.post(baseURL + "/userApi/deleteAuth", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      centerDialog.value.isShow = false
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        ElMessage.success(res.data.msg);
        setTimeout(() => {
          getUserInfo()
        }, 200);
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      centerDialog.value.isShow = false
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const setTimeMeal = (select_option: string) => {
  var element = time_meal_data.value.time_meal_list.filter(item => item.meal_id == select_option);
  time_meal_data.value.num = 1
  time_meal_data.value.min = element[0].min
  time_meal_data.value.max = element[0].max
  time_meal_data.value.unit = element[0].time_unit
  time_meal_data.value.price = element[0].price
  time_meal_data.value.meal_id = element[0].meal_id
}
//计算结束时间还有多久
const getEndDateColor = (end_date: string) => {
  var endDate = new Date(end_date);
  if (endDate.getTime() < new Date().getTime()) {
    return 3;
  }
  if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
    return 2;
  }
  return 1;
}

onMounted(async () => {
  const globalProperties = getCurrentInstance().appContext.config.globalProperties;
  window.ResizeObserver = globalProperties.$customResizeObserver;
  await getUserInfo()
})
</script>
